import GetReminderResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/GetReminderResponse";
import ReminderUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderUpdateRequest";
import ReminderTranslateModel from "./reminderTranslateModel";

export default class CreateReminderViewModel {
    id?: number = null;
	translations: Array<ReminderTranslateModel> = null;
    initLanguages(langs: string[]) {
        this.translations = (langs || []).map(x => new ReminderTranslateModel({
            langCode: x
        }));
    }
	toServerModel(): ReminderUpdateRequest {
		const req = new ReminderUpdateRequest({
			Id: this.id,            
			Translations: this.translations.map(x=>x.toServerModel())
		});
		
		return req;
	}
	fromServerModel(model: GetReminderResponse) {
		this.id = model.Id;
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.text = serverTranslation.Text;
				tr.title = serverTranslation.Title;
			}
		});
	}
}